import { Helmet } from 'react-helmet';
import Resources from '../components/Resources';

export default function ResourcesPage() {
  return (
    <>
      <Helmet>
        <title>Resources | The Prisu Experts</title>
        <meta
          name="description"
          content="Explore insights, articles, and research from The Prisu Experts on AI, data quality, and global localization."
        />
      </Helmet>
      <Resources />
    </>
  );
}
